import { createStore as vuexCreateStore } from 'vuex';

import global from "@store/modules/global";
import cms from "@store/modules/cms";
import cart from "@store/modules/cart";
import refillCart from "@store/modules/refillCart";
import customer from "@store/modules/customer";
import colorbar from "@store/modules/colorbar";
import modal from "@store/modules/modal";
import siteNav from "@store/modules/siteNav";
import colorAdvisor from "@store/modules/colorAdvisor";
import partial from "@store/modules/partial";
import coupons from "@store/modules/coupons";
import chatWidget from "@store/modules/chatWidget";
import hairColorBarBooking from "@store/modules/hairColorBarBooking";
import quickLook from "@store/modules/quickLook";
import shopCategory from "@store/modules/shopCategory";
import systemSettings from "@store/modules/systemSettings";
import pdp from "@store/modules/pdp";
import subscriptions from "@store/modules/subscriptions";
import productCatalog from "@store/modules/productCatalog";
import xsell from "@store/modules/xsell";
import reviews from "@store/modules/reviews";
import waitlist from "@store/modules/waitlist";
import addressBook from "@store/modules/addressBook";
import constants from '@store/modules/constants';
import payments from '@store/modules/payments';

export function createStore() {
  return vuexCreateStore({
    modules: {
      global,
      cms,
      cart,
      refillCart,
      customer,
      colorbar,
      modal,
      siteNav,
      colorAdvisor,
      partial,
      coupons,
      chatWidget,
      hairColorBarBooking,
      quickLook,
      shopCategory,
      systemSettings,
      pdp,
      subscriptions,
      productCatalog,
      xsell,
      reviews,
      waitlist,
      addressBook,
      constants,
      payments,
    },
    strict: !import.meta.env.PROD,
  });
}
